import { render, staticRenderFns } from "./EditCouponModal.vue?vue&type=template&id=95f0324e"
import script from "./EditCouponModal.vue?vue&type=script&lang=js"
export * from "./EditCouponModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports